var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{attrs:{"value":_vm.drawer,"clipped":_vm.$vuetify.breakpoint.lgAndUp,"app":"","color":`${_vm.isDark ? '#121212' : 'white'}`}},[_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.items.filter(item => {
			// Check user role first
			if (_vm.userRole < item.minRole) {
				return false;
			}

			// Check additional permissions if the role is not sufficient
			if (item.additionalPermissions.length > 0) {
				const permissions = item.additionalPermissions
					.map(permission => _vm.currentUser[permission])
					.filter(permission => permission === true);

				if (permissions.length > 0) {
					return true;
				}
			}

			return true;
		})),function(item,index){return [(item.locked)?_c('v-tooltip',{key:`locked-${index}`,attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('div',_vm._g(_vm._b({},'div',attrs,false),on),[_c('v-list-item',{attrs:{"to":`/${_vm.lang}/${item.route}`,"disabled":true}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.$t(`sidenav-menu.${item.name}`))+" "),_c('v-icon',{staticClass:"ml-1",attrs:{"small":"","color":"grey"}},[_vm._v(" lock ")])],1)],1)],1)],1)]}}],null,true)},[_vm._v(" "+_vm._s(_vm.$t('tooltip.feature-not-available-in-package'))+" ")]):_c('v-list-item',{key:`unlocked-${index}`,attrs:{"to":`/${_vm.lang}/${item.route}`}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.$t(`sidenav-menu.${item.name}`))+" ")])],1)],1)]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }